

























import {
  computed,
  ref,
  defineComponent,
  getCurrentInstance,
  watch,
  onMounted,
  ComponentInternalInstance,
} from "@vue/composition-api";
import { CommonActiveStatus } from "../../ultils/status";
import FormItems from "../../ultils/Form/FormItems.vue";
import ModalWithEditBtn from "../../ultils/Modal/ModalWithEditBtn.vue";
import { AR_UAA01 } from "@/api/constant";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";

import { arClient } from "@/api/ar-client";
import _ from "lodash";
export default defineComponent({
  name: "ModalAccount",
  components: {
    ModalWithEditBtn,
    FormItems,
  },
  props: {
    isShow: Boolean,
    travelAgentId: {
      type: String,
      required: false,
    },
    accountId: {
      type: String,
      required: false,
    },
    listArType: {
      type: Array,
      required: false,
    },
  },
  setup(props, { emit }) {
    const vm = (getCurrentInstance() as ComponentInternalInstance).proxy;
    const modalRef = ref();

    const formData = ref({ InActive: 1 });
    const formRef = ref();
    const accountId = computed(() => props.accountId);
    const accountParams = computed(() => {
      return {
        ArAccount: {
          Id: accountId.value,
        },
      };
    });
    const formItems = computed(() => [
      {
        type: "cleave",
        cleaveType: "uppercase",
        name: "AccountCode",
        rules: { code: true, min: 2 },
        disabled: accountId.value,
        required: true,
        label: "ar_client_debit_account_code",
      },
      {
        type: "select",
        name: "PropertyId",
        required: true,
        disabled: accountId.value,
        dataSourceParams:{
          IsCheckPermission:false
        },
        dataSource: vm.arClient.api_AR_RPE01,
        labelOption: "PropertyName",
        label: "ar_client_site_code",
      },
      {
        type: "cleave",
        cleaveType: "currency",
        disabled: accountId.value,
        name: "CreditLimit",
        label: "ar_client_account_credit_limit",
      },
      {
        type: "cleave",
        cleaveType: "currency",
        disabled: accountId.value,
        name: "CreditLimitDays",
        label: "ar_client_account_credit_limit_day",
      },
      {
        type: "cleave",
        cleaveType: "currency",
        disabled: accountId.value,
        labelAfterFix: " (VND)",
        defaultValue: 0,
        name: "CreditBalance",
        label: "ar_client_account_credit_balances",
      },
      {
        type: "cleave",
        defaultValue: 0,
        cleaveType: "currency",
        disabled: accountId.value,
        required: true,
        labelAfterFix: " (VND)",
        name: "DebitBalance",
        label: "ar_client_account_dedit_balances",
      },
      {
        type: "select",
        dataSource: CommonActiveStatus.map((stt) => ({ Label: vm.$t(stt.title), Id: stt.value })),
        noClearable: true,
        hide: !accountId.value,
        name: "InActive",
        labelOption: "Label",
        label: "ar_client_status",
        wrapperClass: "col-6",
      },
      {
        wrapperClass: "col-12",
        type: "string",
        variant: "textarea",
        name: "DescriptionVi",
        label: "ar_client_note",
      },
    ]);
    const { fetchData } = useFetch(
      accountId.value ? arClient.api_AR_UAA01 : arClient.api_AR_IAA01,
      {
        showLoading: true,
        afterErrorOrTimeoutFunction: {
          func: () => modalRef.value.stopLoadingButton(),
        },
        nextFunction: () => {
          emit("refetch");
        },
      }
    );
    const { data: detailAccount, fetchData: fetchDetailAccount } = useFetch(arClient.api_AR_RAA02, {
      showLoading: true,
      loadingMessage: "ar_common_get_detail",
      disableSuccessMessage: true,
      params: accountParams,

      nextFunction: (data) => {
        formData.value = data.ArAccount;
      },
    });
    onMounted(() => {
      if (accountId.value) fetchDetailAccount();
    });
    const createUpdateAccount = () => {
      formRef.value.validate().then((success) => {
        if (success) {
          modalRef.value.startLoadingButton();
          const body = formData.value;

          body.TravelAgentId = props.travelAgentId;
          body.ArTypeId = "c1066013-97d7-4177-88be-853093a98cea";
          const deleteFields = ["IsDeleted", "GlobalId", "CreatedDate"];
          if (accountId.value) {
            deleteFields.forEach((field) => {
              delete body[field];
            });
            body.Id = accountId.value;
          }
          fetchData({ ArAccount: body });
        }
      });
    };

    return {
      AR_UAA01,
      formData,
      formItems,
      createUpdateAccount,
      formRef,
      fetchDetailAccount,
      detailAccount,
      modalRef,
    };
  },
});
